export const traineesPropName = 'trainees__a';
export const trainessPreviewPropName = 'trainees_preview__a';
export const smartGroupPropName = 'smart_groups__a';
export const smartGroupPreviewPropName = 'smart_groups_preview__a';
export const trainingRolesPropName = 'training_roles__a';
export const trainingRolesPreviewPropName = 'training_roles_preview__a';
